export default "__VITE_ASSET__sCSexmTk__"